/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_Fact_LiveInputs */

const en_coaches_page_fact_live = /** @type {(inputs: Coaches_Page_Fact_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hours live from their calendars`)
};

const pl_coaches_page_fact_live = /** @type {(inputs: Coaches_Page_Fact_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Godziny na żywo z kalendarzy`)
};

/**
* | output |
* | --- |
* | "Hours live from their calendars" |
*
* @param {Coaches_Page_Fact_LiveInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_fact_live = /** @type {((inputs?: Coaches_Page_Fact_LiveInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_Fact_LiveInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_fact_live(inputs)
	return en_coaches_page_fact_live(inputs)
});